import { render, staticRenderFns } from "./ShipReportList.vue?vue&type=template&id=bb2f905a&scoped=true"
import script from "./ShipReportList.vue?vue&type=script&lang=js"
export * from "./ShipReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2f905a",
  null
  
)

export default component.exports